import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step11View from './Step11-view';
import {checkRequiredValues} from '../../utils/forms/checkRequiredValues';
import types from '../../types';
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step11 = ({
                  submitStep,
                  regType,
                  payload,
                  prevCompletedStepSign,
                  prevCompletedStepSignFalse,
                }) => {
  const {
    otherIncomeExists,
    creditPoints,
    ...restPayload
  } = payload;
  const initialValues = {
    otherIncomeExists: (otherIncomeExists) ? 'otherIncomes' : 'noIncomes',
    monthlyIncome: false,
    additionalIncome: false,
    partlyIncome: false,
    dailyWorkIncome: false,
    allowance: false,
    allowanceBituahLeumi: null,
    allowancePension: null,
    scholarship: false,
    otherIncome: false,
    otherIncomeFreeText: '',
    creditPoints: creditPoints || '',
    secretionSavings: false,
    secretionInsurance: false,
    ...restPayload
  };

  const validate = values => {
    const {
      otherIncomeExists,
      otherIncome,
      otherIncomeFreeText,
      allowance,
      allowancePension,
      allowanceBituahLeumi,
      creditPoints,
    } = values;

    let errors = {};
    errors = checkRequiredValues({otherIncomeExists}, errors);
    if (otherIncomeExists === 'otherIncomes') errors = checkRequiredValues({creditPoints}, errors);
    if (otherIncome) errors = checkRequiredValues({otherIncomeFreeText}, errors);
    if (allowance && !(allowancePension || allowanceBituahLeumi)) {
      errors = checkRequiredValues({allowancePension, allowanceBituahLeumi}, errors);
    }

    return errors;
  };

  const {formatMessage} = useIntl();

  const handleSubmit = values => {
    const {
      otherIncomeExists,
      allowance,
      allowancePension,
      allowanceBituahLeumi,
      ...data
    } = values;
    const allowanceData = allowance
      ? {allowancePension: allowancePension || null, allowanceBituahLeumi: allowanceBituahLeumi || null}
      : {allowancePension: null, allowanceBituahLeumi: null};

    submitStep({
      step: 11,
      data: {
        regType,
        otherIncomeExists: otherIncomeExists === 'otherIncomes',
        prevCompletedStepSign,
        allowance,
        ...allowanceData,
        ...data,
      },
    })
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 11,
            step_name_en: 'Income tax',
            step_name_he: formatMessage({id: 'step11.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.log({err}));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({values, isValid, submitCount}) => (
        <Step11View
          values={values}
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step11.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  payload: PropTypes.object,
  submitStep: PropTypes.func
};

export default Step11;
